import React from 'react'
import Head from 'next/head'
import Link from 'next/link'
import Menu from '../components/Menu'
import Block from '../components/Block'
import { NextSeo } from 'next-seo'
import team from '../data/team.yml'
import Footer from '../components/Footer'
import RegistrationButton from '../components/RegistrationButton'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { fab, faGithub, faTwitter } from '@fortawesome/free-brands-svg-icons'
import { useRouter } from 'next/router'

// import { faGreaterThanEqual } from '@fortawesome/free-solid-svg-icons'
// See https://github.com/FortAwesome/Font-Awesome/tree/master/js-packages/%40fortawesome/free-solid-svg-icons

const rewriteStaticAssetPath = (path) => {
  const { basePath } = useRouter();
  
  if (path.match(/^http/)) {
    return path
  } else {
    return basePath + path
  }
}

const Team = props =>
      <div id="main-container">
        <NextSeo openGraph={{
          title: 'チーム | PyCon mini Hiroshima 2019',
          description: 'PyCon mini Hiroshima 2019 のチーム'
        }} />

        <header>
          <Menu />
        </header>

        <div role='main'>
          <div>
            <h1 className='block'>チーム</h1>
          </div>
          
          <Block>
            <div className='team'>
              { team.map(
                member =>
                  <div className='team-member'>
                    { member.image &&
                      <figure className='person-picture' >
                        <img src={rewriteStaticAssetPath(member.image)} />
                      </figure> }
                    <div className='member-position-and-name'>
                      { member.type &&
                        <span className='member-type'>{member.type}</span>}
                      <span className='member-name'>{member.name}</span>
                    </div>
                    <ul className='social-links'>
                      { member.github &&
                        <li className='github'><a href={`https://github.com/${member.github}`}><FontAwesomeIcon icon={faGithub} /></a></li>}
                      { member.twitter &&
                        <li className='twitter'><a href={`https://twitter.com/${member.twitter}`}><FontAwesomeIcon icon={faTwitter} /></a></li>}
                    </ul>
                  </div>
              )}
            </div>
          </Block>

        </div>

        <RegistrationButton />
        <Footer/>
      </div>

      Team.getInitialProps = async function() {
      };

export default Team;
